/**
 * To top Button
 */
export const bootToTopBtn = () => {
	$(".to-top-js").on("click", function () {
		$('html, body').animate({scrollTop: 0}, 1000);
	});
	/*Scroll top*/
	$(window).scroll(function(){
		if ($(this).scrollTop() > 100) {
			$(".to-top-js").removeClass('hidden');
		}
		else {
			$(".to-top-js").addClass('hidden');
		}
	});
}

/**
 * Mobile Menu
 */
export const bootTrigger = () => {
	/*Menu*/
	$(".trigger").on('click',function () {
		$('.main-menu').slideToggle();
		$(this).toggleClass("opened");
		$('html,body').toggleClass("shadow");
	});
}
